import { FeatureRollout } from "@shared/types";

import { authGet } from "./auth";

export const fetchActiveFeatures = (): Promise<FeatureRollout[]> =>
  authGet<{ features: FeatureRollout[] }>("/api/agent/features").then(
    (response) => response.features
  );
